import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import {
    Row, Col
} from 'react-bootstrap'

export default function SaleOrdersShippingMethod(props) {
    const { order, setOrder, currency } = props

    const [cost, setCost_] = useState(order.shippingCost)
    const [shippingType, setType_] = useState(order.shippingType)

    const setData = (c, t) => {
        setCost_(c)
        setType_(t)
        order.shippingCost = c
        order.shippingType = t
        setOrder(order)
    }
    const setCost = (d) => {
        setCost_(d)
        order.shippingCost = d
        order.shippingType = shippingType
        setOrder(order)
    }

    useEffect(() => {
        setCost_(order.shippingCost)
        setType_(order.shippingType)
    }, [props])
    const formik = useFormik({
    })
    return (
        <div className="app-card w-50">
            <Row>
                <Col xs={12} md={9} lg={12} className="px-0">
                    <div className="app-header-wrapper pad-12-LR">
                        <p className="app-heading text-capitalize app-heading-bold app-heading-label mb-2">Shipping Method</p>
                    </div>
                </Col>
            </Row>
            <div className="app-card-content bg-white border st-border-dark st-default-rounded-block overflow-hidden">
                <Row className="app-card-content st-border-light d-flex align-items-center mx-0 pad-12" style={{ backgroundColor: "#F9FBFC", minHeight: 401 }}>
                    <div className="media-body st-form-input-container align-left pt-2">
                        <Row className="pad-15-B">
                            <Col xs={12} md={9} lg={8} className="text-capitalize st-fs-14 regular-shipping">
                                <input type="radio" className="custom-radio"
                                    checked={shippingType === "Regular Shipping"}
                                    onChange={e => {
                                        setData("0", "Regular Shipping")
                                    }}
                                /> {` Regular Shipping`}
                                <span>Estimated arrival on: Sep 17 - Sep 22</span>
                            </Col>
                            <Col xs={12} md={9} lg={4} className="st-fs-20 text-right">Free</Col>
                        </Row>
                        <Row className="pad-15-B">
                            <Col xs={12} md={9} lg={8} className="text-capitalize st-fs-14">
                                <input type="radio" className="custom-radio"
                                    checked={shippingType === "Next Day"}
                                    onChange={e => {
                                        setData("600", "Next Day")
                                    }}
                                />{` Next Day`}
                            </Col>
                            <Col xs={12} md={9} lg={4} className="st-fs-20 text-right">{currency}600.00</Col>
                        </Row>
                        <Row className="pad-15-B">
                            <Col xs={12} md={9} lg={8} className="text-capitalize st-fs-14">
                                <input type="radio" className="custom-radio"
                                    value={1}
                                    checked={shippingType === "2 Day Shipping"}
                                    onChange={e => {
                                        setData("400", "2 Day Shipping")
                                    }}
                                />{` 2 Days Shipping`}
                            </Col>
                            <Col xs={12} md={9} lg={4} className="st-fs-20 text-right">{currency}400.00</Col>
                        </Row>
                        <Row className="pad-15-B">
                            <Col xs={12} md={9} lg={8} className="text-capitalize st-fs-14">
                                <input type="radio" className="custom-radio"
                                    checked={(shippingType !== "Regular Shipping" && shippingType !== "2 Day Shipping" && shippingType !== "Next Day")}
                                    onChange={e => {
                                        setData("0", "")
                                    }}
                                />{` Custom Shipping Method`}
                            </Col>
                        </Row>
                        <div className="shipping-method-input  pad-20-B">
                            <input
                                className="form-control"
                                placeholder="Shipping Method"
                                id="shipping_method"
                                disabled={!(shippingType !== "Regular Shipping" && shippingType !== "2 Day Shipping" && shippingType !== "Next Day")}
                                type="text"
                                value={shippingType}
                                onChange={(e) => {
                                    setData(cost, e.target.value)
                                }}
                            />

                            <span className="st-fs-13">Custom shipping method is not applicable to Draft Order</span>
                        </div>
                        <div className="shipping-method-input p-0">
                            <input
                                className="form-control"
                                placeholder="Enter cost"
                                id="cost"
                                disabled={!(shippingType !== "Regular Shipping" && shippingType !== "2 Day Shipping" && shippingType !== "Next Day")}
                                value={cost}
                                type="number"
                                onChange={(e) => { setCost(e.target.value) }}
                            />
                            <span>Cost</span>
                        </div>
                        {
                            (formik.touched.active && formik.errors.active) && (
                                <div className="st-form-msg position-absolute">
                                    <p className="st-fs-12">{formik.errors.active}</p>
                                </div>
                            )
                        }
                    </div>
                </Row>
            </div>
        </div>
    )
}
